var module = angular.module('octopusApp.library');

module.controller('DefaultActionPropertyValuesController', function ($scope, $uibModalInstance, parameters, defaultPropertyValues, actionTemplateName, isGlobalUpdate) {
    $scope.parameters = parameters;
    $scope.defaultPropertyValues = defaultPropertyValues;
    $scope.actionTemplateName = actionTemplateName;
    $scope.isGlobalUpdate = isGlobalUpdate;

    $scope.apply = function () {
        $uibModalInstance.close($scope.defaultPropertyValues);
    };

    $scope.cancel = function () {
        $uibModalInstance.dismiss();
    };
});


//////////////////
// WEBPACK FOOTER
// ./app/areas/library/steps/controllers/default_action_property_values_controller.js
// module id = 465
// module chunks = 1